import React from "react";
import {
 Box,
 Heading,
 SimpleGrid,
 List,
 ListItem,
 ListIcon,
 Text,
 Stat,
 StatLabel,
 StatNumber,
 StatHelpText,
 Divider,
} from "@chakra-ui/react";
import { Award, TrendingUp, Briefcase } from "lucide-react";

const ScholarshipsPlacementsSection = ({ scholarships, placements }) => {
 const hasScholarships = scholarships && scholarships.length > 0;
 const hasPlacements =
  placements &&
  (placements.averagePackage ||
   placements.highestPackage ||
   (placements.companies && placements.companies.length > 0));

 if (!hasScholarships && !hasPlacements) {
  return null;
 }

 return (
  <Box mb={8}>
   <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
    {/* Scholarships Section */}
    {hasScholarships && (
     <Box p={5} bg="gray.50" borderRadius="md" boxShadow="sm">
      <Heading as="h3" size="md" mb={4} display="flex" alignItems="center">
       <Box as={Award} mr={2} color="gold" />
       Scholarships
      </Heading>

      <List spacing={2}>
       {scholarships.map((scholarship, index) => (
        <ListItem key={index} display="flex" alignItems="flex-start">
         <ListIcon as={Award} color="yellow.500" marginTop="0.3em" />
         <Text>{scholarship}</Text>
        </ListItem>
       ))}
      </List>
     </Box>
    )}

    {/* Placements Section */}
    {hasPlacements && (
     <Box p={5} bg="gray.50" borderRadius="md" boxShadow="sm">
      <Heading as="h3" size="md" mb={4} display="flex" alignItems="center">
       <Box as={Briefcase} mr={2} color="blue.600" />
       Placements
      </Heading>

      <SimpleGrid columns={2} mb={4}>
       {placements.averagePackage && (
        <Stat>
         <StatLabel fontSize="xs">Average Package</StatLabel>
         <StatNumber color="blue.600">
          ₹{placements.averagePackage} LPA
         </StatNumber>
         <StatHelpText>
          <Box as={TrendingUp} display="inline" size={16} /> Annual
         </StatHelpText>
        </Stat>
       )}

       {placements.highestPackage && (
        <Stat>
         <StatLabel fontSize="xs">Highest Package</StatLabel>
         <StatNumber color="green.600">
          ₹{placements.highestPackage} LPA
         </StatNumber>
         <StatHelpText>
          <Box as={TrendingUp} display="inline" size={16} /> Annual
         </StatHelpText>
        </Stat>
       )}
      </SimpleGrid>

      {placements.companies && placements.companies.length > 0 && (
       <>
        <Divider my={3} />
        <Text fontWeight="medium" mb={2} fontSize="sm">
         Top Recruiting Companies:
        </Text>
        <Text fontSize="sm" color="gray.600">
         {placements.companies.join(", ")}
        </Text>
       </>
      )}
     </Box>
    )}
   </SimpleGrid>
  </Box>
 );
};

export default ScholarshipsPlacementsSection;
